/* global google */
import React from 'react';
import imgResolver from '../utils/img-resolver';


class GoogleMap extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            map: null,
            marker: null
        }
    }

    componentDidMount() {
        const mapElement = React.findDOMNode(this.refs.googleMap);
        const latLng = new google.maps.LatLng(this.props.center.lat, this.props.center.lng);
        const options = {
            center: latLng,
            zoom: this.props.zoom,
            scrollwheel: this.props.scrollwheel,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            draggable: false,
            disableDefaultUI: true,
            keyboardShortcuts: false
        };
        const map = new google.maps.Map(mapElement, options);
        /*const icon = {
            url: '../styles/images/map_location_marker.png',
            fillColor: '#FE784D',
            fillOpacity: 1,
            anchor: new google.maps.Point(18,35),
            strokeWeight: 0,
            scale: 1
        };*/
        const marker = new google.maps.Marker({
            position: latLng,
            draggable: false,
            map: map,
            icon: require('../styles/images/map_location_marker.png')
        });

        this.setState({
            marker,
            map
        })
    }

    componentDidUpdate() {
        if (this.state.map && this.state.marker) {
            const latLng = new google.maps.LatLng(this.props.center.lat, this.props.center.lng);
            this.state.map.panTo(latLng);
            this.state.marker.setPosition(latLng)
        }
    }

    render() {
        return (
            <div ref="googleMap" id="googleMap" className="google-map"></div>
        )
    }
}

export default GoogleMap;



/** WEBPACK FOOTER **
 ** ./app/src/components/GoogleMap.js
 **/